<template>
<div class="pt-0 ptHeader mainBackVaillant widthFull mb-5">
  <loading v-if="loadingState" />
  <div class="container  mb-5">

    <!--   HEADER TITLE    ///////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
    <div class="row justify-content-center text-left">
      <h3 class="Regular  h0 widthFull"><b> Superbonus 110% </b></h3>

    </div>

    <div class="row justify-content-center text-left vaillantCont mb-5">

      <div class="col-md-12">
        <h5>Se vuoi gestire una pratica di Cessione del credito per il Superbonus 110% questi sono il documenti necessari
          <br/>( seleziona l'elenco in base al tipo di unita immobiliare oggetto dell'intervento )</h5>
      </div>

      <div class="col-md-12">


        <ul class="nav nav-tabs mt-5" id="myTab" role="tablist">
          <li class="nav-item">
            <a class="nav-link active black" id="home-tab" data-toggle="tab" href="#home" role="tab" aria-controls="home" aria-selected="true">Unità Singola</a>
          </li>
          <li class="nav-item">
            <a class="nav-link black" id="profile-tab" data-toggle="tab" href="#profile" role="tab" aria-controls="profile" aria-selected="false">Condominio</a>
          </li>

        </ul>
        <div class="tab-content" id="myTabContent">
          <div class="tab-pane fade show active center" id="home" role="tabpanel" aria-labelledby="home-tab">
            <div class="row justify-content-center">
              <div class="col-md-9">
                <img class="img-fluid widthFull mt-4" src="../../assets/images/doc_singola.jpg">
              </div>
            </div>
          </div>
          <div class="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">
            <div class="row justify-content-center">
              <div class="col-md-9">
                <img class="img-fluid widthFull mt-4" src="../../assets/images/doc_condominio.jpg">
              </div>
            </div>
          </div>
        </div>



      </div>




      <div class="col-md-12 mb-5 mt-5 center">
        <h5>Per procedere con la gestione della pratica contatta il supporto clienti al numero 02 9475 6677
          <br/> oppure invia una mail a <a class="link yellow" href="mailto:info@chebonus.it" >info@chebonus.it</a></h5>

      </div>

      <div class="col-md-12 mb-5  center">
        <router-link class="btn btn-primary" to="/calcolatore">Indietro</router-link>
      </div>

    </div>


  </div>

</div>

</div>
</template>

<script>
import {
  AUTH_REQUEST,
  AUTH_SOCIAL
} from 'actions/auth'
import {
  mapGetters,
  mapState
} from 'vuex'
import axios from 'axios'
import {
  BadgerAccordion,
  BadgerAccordionItem
} from 'vue-badger-accordion'
const moment = require('moment')

import {
  VueSvgGauge
} from 'vue-svg-gauge'

export default {
  name: 'superbonus',
  components: {
    BadgerAccordion,
    BadgerAccordionItem,
    VueSvgGauge
  },
  data() {
    return {
      token: '',
      loadingState: false,
      loading: false,
      practices: {},
      countPractices: 0,
      countCashClient: 0,
      countCashInst: 0,
      practicesFiltred: {},
      filter: '',
      presentPractices: true,
      moment: require('moment'),
      maxTotCash: 1000000,
      totCash: 0,
      step: 1000,
      showFilterText: false,
      hasRemovedPractics: false,
    }
  },
  methods: {
    async getPractices() {
      var _vue = this
      this.loadingState = true
      console.log(_vue.getProfile.userToken)
      var token = _vue.getProfile.userToken
      if (token) {
        await axios({
            url: process.env.ROOT_API + 'api/getPractices',
            method: 'POST',
            data: {
              type: 0,
              user_token: token
            },
            headers: {
              'Authorization': 'Bearer ' + process.env.AUTH_TOKEN,
              'Content-type': 'application/json'
            }
          })
          .then(resp => {

            _vue.practices = resp.data.practices
            _vue.totCash = 0
            _vue.countPractices = 0
            _vue.countCashInst = 0
            _vue.countCashClient = 0
            for (var x in _vue.practices) {
              if (_vue.practices[x].status == '0') {
                // CALC ONLY VALID ORDERS
                _vue.countPractices++
                _vue.totCash = (parseFloat(_vue.totCash) + parseFloat(_vue.practices[x].total_work_and_iva)).toFixed(2)

                _vue.countCashInst = (parseFloat(_vue.countCashInst) + parseFloat(_vue.practices[x].total_transfer_for_user)).toFixed(2)
                _vue.countCashClient = (parseFloat(_vue.countCashClient) + parseFloat(_vue.practices[x].total_transfer_for_client)).toFixed(2)
              }

              if (_vue.practices[x].status == '9') {
                _vue.hasRemovedPractics = true
              }


            }
            this.totCash = parseFloat(this.totCash)
            if (this.totCash < 10000) {
              this.maxTotCash = 10000
              this.step = 1000
            } else if (this.totCash < 100000) {
              this.maxTotCash = 100000
              this.step = 10000
            } else if (this.totCash < 1000000) {
              this.maxTotCash = 1000000
              this.step = 100000
            } else if (this.totCash < 100000000) {
              this.maxTotCash = 100000000
              this.step = 1000000
            }
            _vue.practicesFiltred = _vue.practices

            _vue.loadingState = false

          })
          .catch(resp => {

            this.presentPractices = false
            _vue.loadingState = false
            //_vue.$swal({
            //  type: 'error',
            //  title: 'Oops...',
            //  text: 'Riprova piu tardi!',
            //});

          })
      }

    },
    filterValues() {
      var text = this.filter.toLowerCase()
      console.log(text)
      this.practicesFiltred = {}
      var z = 0

      for (var x in this.practices) {
        if (this.practices[x].code.toLowerCase().includes(text) || this.practices[x].client_lastname.toLowerCase().includes(text) || this.practices[x].client_name.toLowerCase().includes(text) || this.practices[x].building_city.toLowerCase().includes(
            text)) {
          this.practicesFiltred[x] = this.practices[x]
          z = z + 1
        }
      }

      if (z == 0) {
        this.showFilterText = true
      } else {
        this.showFilterText = false
      }

    },
    removeOrder(id, code, key) {
      var id_order = id
      var _vue = this

      if (key == 'restore') {
        var type = 0
        var popUpText = '<br/>Sei sicuro di voler ripristinare Preventivo N. ' + code + '?<br/><br/>'
      } else {
        var type = 9
        var popUpText = '<br/>Sei sicuro di voler eliminare Preventivo N. ' + code + '?<br/><br/>'
      }

      this.$swal({
        title: 'Attenzione!',
        type: 'warning',
        html: popUpText,
        showCancelButton: true,
        confirmButtonText: `SI`,
        cancelButtonText: `NO`,
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        console.log(result)
        if (result.value) {

          axios({
              url: process.env.ROOT_API + 'api/changeOrderState',
              method: 'POST',
              data: {
                id: id,
                user_token: _vue.getProfile.userToken,
                status: type
              },
              headers: {
                'Authorization': 'Bearer ' + process.env.AUTH_TOKEN,
                'Content-type': 'application/json'
              }
            })
            .then(resp => {

              _vue.getPractices()

              if (key == 'restore') {
                _vue.$swal('Preventivo N. ' + code + ' <br/>è stato ripristinato ', '', 'success')
              } else {
                _vue.$swal('Preventivo N. ' + code + ' <br/>è stato eliminato ', '', 'success')
              }

            })
            .catch(resp => {
              _vue.$swal('Ops. Riprova piu tardi', '', 'error')
            })

        }
      })

    },
    showAlert() {
      // Use sweetalret2
      this.$swal({
        type: 'error',
        title: 'Oops...',
        text: 'Something went wrong!',
      });
    },

  },
  watch: {
    getProfile: function(val) {
      if (val) {
        console.log(val)
        this.getPractices()
      }
    },
    filter: function(val) {
      this.filterValues()
    },
  },
  created() {

  },
  mounted() {

    if (this.getProfile) {
      this.getPractices()
    }

    this.$scrollTo('#app', 700, {
      offset: -75
    })

  },
  computed: {
    ...mapGetters(['getProfile', 'loginerror', 'isAuthenticated', 'isProfileLoaded', 'authStatus']),
    ...mapState({
      //response: state => `${state.status.response.data}`,
    })
  },
}
</script>



// WEBPACK FOOTER //
// src/components/superbonus/index.vue